import { useEffect, useState } from "react";
import { CurrencyInr, Percent, Wallet } from "@phosphor-icons/react";
import { DashboardLayout } from "@/components/DashboardLayout";
import { ownerNav } from "@/config/nav";
import api, { formatINR } from "@/lib/api";
import { StatSkeleton } from "@/components/Loaders";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function OwnerEarnings() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/owner/earnings").then((r) => setData(r.data)); }, []);

  const cards = data
    ? [
        { label: "Total Booking Value", value: formatINR(data.total_booking_value), icon: CurrencyInr },
        { label: "Platform Commission", value: formatINR(data.estimated_commission), icon: Percent },
        { label: "Your Estimated Earnings", value: formatINR(data.estimated_earnings), icon: Wallet },
      ]
    : [];

  return (
    <DashboardLayout nav={ownerNav} title="Owner">
      <h1 className="font-heading text-2xl font-semibold text-stone-900 md:text-3xl">Earnings</h1>
      <p className="mt-1 text-sm text-stone-500">Based on confirmed & completed bookings. Payouts will be enabled in a future update.</p>

      <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
        {!data
          ? [1, 2, 3].map((i) => <StatSkeleton key={i} />)
          : cards.map((c) => {
              const Icon = c.icon;
              return (
                <div key={c.label} className="rounded-2xl border border-stone-200 bg-white p-6">
                  <div className="flex items-center justify-between">
                    <p className="text-xs uppercase tracking-wide text-stone-400">{c.label}</p>
                    <Icon size={20} weight="duotone" className="text-primary" />
                  </div>
                  <p className="mt-3 font-heading text-2xl font-bold text-stone-900 tabular-nums">{c.value}</p>
                </div>
              );
            })}
      </div>

      <div className="mt-8 overflow-hidden rounded-2xl border border-stone-200 bg-white">
        <div className="border-b border-stone-100 px-6 py-4"><h2 className="font-heading font-semibold">Transaction History</h2></div>
        {data && data.records.length === 0 ? (
          <p className="px-6 py-10 text-center text-sm text-stone-500">No confirmed bookings yet.</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Booking ID</TableHead><TableHead>Property</TableHead><TableHead>Date</TableHead>
                <TableHead className="text-right">Value</TableHead><TableHead className="text-right">Commission</TableHead><TableHead className="text-right">Payout</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {(data?.records || []).map((r) => (
                <TableRow key={r.id}>
                  <TableCell className="font-mono text-xs">{r.booking_ref}</TableCell>
                  <TableCell>{r.property_name}</TableCell>
                  <TableCell>{r.date}</TableCell>
                  <TableCell className="text-right tabular-nums">{formatINR(r.base_price)}</TableCell>
                  <TableCell className="text-right tabular-nums text-red-600">-{formatINR(r.commission_amount)}</TableCell>
                  <TableCell className="text-right font-semibold tabular-nums text-primary">{formatINR(r.owner_payout)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </DashboardLayout>
  );
}
